export default {
  toggleReOpenSupportQueryModel: false,
}
